export const MODEL_OTHER_ID = 2
export const UPLOADED_ITEM_ID = 'uploaded_item_id'
export const UPLOAD_SESSION_ID = 'upload_session_id'
export const UPLOADED_ITEM_PROMOTIONS = 'uploaded_item_promotions'

export enum PromotionStorageKeys {
  ShowBumped = 'pushed_up_promotion',
  ShowFeedback = 'feedback_promotion',
  ShowUploadAnotherItemTip = 'upload_another_item_tip_promotion',
}

export enum ItemAfterUploadActions {
  ShowUploadAnotherItemTip = 'show_upload_another_item_tip',
  ShowEVSModal = 'show_electronics_verification_modal',
  ShowIVSModal = 'show_item_verification_modal',
  ShowBumpsCheckout = 'show_bumps_checkout',
}

export const REQUEST_DELAY = 500

export enum BookDetailStatus {
  Found = 'found',
  NotFound = 'not found',
}

export enum IsbnValidity {
  Unvalidated = 'unvalidated',
  Valid = 'valid',
  Invalid = 'invalid',
}

export enum SelectionSource {
  Default = 'default',
  Suggestion = 'suggestion',
  Prefill = 'prefill',
  Search = 'search',
}

// TODO: Replace usage of FieldName with ItemUploadFieldName
export enum FieldName {
  Root = 'root',
  Title = 'title',
  Size = 'size_id',
  Model = 'model',
  Description = 'description',
  Price = 'price',
  PackageSize = 'package_size_id',
  DomesticShipmentPrice = 'shipment_prices.domestic',
  InternationalShipmentPrice = 'shipment_prices.international',
  Catalog = 'catalog_id',
  Color = 'color',
  Photos = 'photos',
  Isbn = 'isbn',
  Gender = 'gender_id',
  ShippingFromLocation = 'shipping_from_location',
  ShippingSettingsNearby = 'nearby_carriers',
  ShippingSettingsDistant = 'distant_carriers',
  ShippingSettingsUnknownDistance = 'unknown_distance_carriers',
  ShippingMethod = 'shipping_method',
  Bump = 'bump',
  Manufacturer = 'manufacturer',
  ManufacturerLabel = 'manufacturer_labelling',
  ParcelHeight = 'parcel_dimensions_height',
  ParcelWidth = 'parcel_dimensions_width',
  ParcelLength = 'parcel_dimensions_length',
  ParcelWeight = 'parcel_weight',
}

export enum ItemUploadFailReason {
  ValidationError = 'validation_error',
  ServerError = 'server_error',
  Other = 'other',
}

// TODO: Replace usage of CatalogGroupFieldCodes with ItemUploadFieldName
export enum CatalogGroupFieldCodes {
  Gender = 'gender',
  Isbn = 'isbn',
  Author = 'author',
  BookTitle = 'book_title',
  Size = 'size',
  Color = 'color',
  Material = 'material',
  Manufacturer = 'manufacturer',
  ManufacturerLabel = 'manufacturer_labelling',
  Model = 'model',
}

export enum ItemUploadFieldName {
  Catalog = 'catalog',
  Unisex = 'unisex',
  Brand = 'brand',
  VideoGamePlatform = 'video_game_platform',
  Condition = 'condition',
  Model = 'model',
  Price = 'price',
  PackageSize = 'package_size',
  VideoGameRating = 'video_game_rating',
  Measurements = 'measurements',
  MeasurementWidth = 'measurement_width',
  MeasurementLength = 'measurement_length',
}

export enum ItemStatus {
  New = 'upload_item',
  Edit = 'edit_item',
  DraftEdit = 'edit_draft',
}

export const WITHOUT_BRAND_ID = 1 // Should match Brand::ID_EMPTY (from backend)

export enum FieldTrackingName {
  Author = 'author',
  BookTitle = 'book_title',
  Bump = 'bump',
  Catalog = 'category',
  Category = 'category',
  CategorySearch = 'category_search',
  Color = 'color',
  Condition = 'condition',
  Description = 'description',
  Gender = 'gender',
  Isbn = 'isbn',
  Manufacturer = 'manufacturer_credentials',
  ManufacturerLabel = 'labeling_info',
  Material = 'material',
  Model = 'model',
  PackageSize = 'package_size',
  Photo = 'photo',
  Price = 'price',
  Size = 'size',
  Title = 'title',
}

export const MULTIPLE_SIZE_GROUPS_HEADER = {
  'X-Enable-Multiple-Size-Groups': 'true',
}

export enum Measurements {
  Imperial = 'imperial',
  Metric = 'metric',
}
